import { useState } from 'react';

const s = {
  page: { minHeight: '100vh', backgroundColor: '#f5f5f3', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' },
  card: { backgroundColor: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '8px', padding: '40px', width: '100%', maxWidth: '380px' },
  header: { marginBottom: '28px' },
  title: { fontSize: '18px', fontWeight: '700', color: '#1a1a1a', letterSpacing: '-0.3px', marginBottom: '4px' },
  subtitle: { fontSize: '12px', color: '#aaa' },
  error: { backgroundColor: '#fdecea', color: '#c0392b', padding: '10px 14px', borderRadius: '6px', marginBottom: '16px', fontSize: '13px' },
  success: { backgroundColor: '#f0faf4', color: '#2e7d32', padding: '10px 14px', borderRadius: '6px', marginBottom: '16px', fontSize: '13px' },
  label: { display: 'block', fontSize: '12px', fontWeight: '500', color: '#666', marginBottom: '6px' },
  input: { width: '100%', padding: '9px 12px', border: '0.5px solid #e0e0e0', borderRadius: '6px', fontSize: '13px', outline: 'none', color: '#1a1a1a', marginBottom: '16px', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '10px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' },
  btnDisabled: { width: '100%', padding: '10px', backgroundColor: '#ccc', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '500' },
  footer: { marginTop: '20px', textAlign: 'center', fontSize: '12px', color: '#aaa' },
  link: { color: '#1a1a1a', textDecoration: 'none', fontWeight: '500' },
  backLink: { display: 'block', textAlign: 'center', marginTop: '16px', fontSize: '12px', color: '#bbb', textDecoration: 'none' },
};

function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: form.name, email: form.email, password: form.password })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Registration failed'); return; }
      setSuccess('Account created. Please check your email to verify your account.');
      setForm({ name: '', email: '', password: '', confirmPassword: '' });
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.header}>
          <p style={s.title}>Menu Board</p>
          <p style={s.subtitle}>Create your restaurant account</p>
        </div>
        {error && <p style={s.error}>{error}</p>}
        {success && <p style={s.success}>{success}</p>}
        <form onSubmit={handleSubmit}>
          <label style={s.label}>Restaurant Name</label>
          <input style={s.input} type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          <label style={s.label}>Password</label>
          <input style={s.input} type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
          <label style={s.label}>Confirm Password</label>
          <input style={s.input} type="password" value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })} required />
          <button style={loading ? s.btnDisabled : s.btn} type="submit" disabled={loading}>
            {loading ? 'Creating account...' : 'Create account'}
          </button>
        </form>
        <p style={s.footer}>Already have an account? <a href="/login" style={s.link}>Sign in</a></p>
        <a href="/" style={s.backLink}>Back to home</a>
      </div>
    </div>
  );
}

export default Register;
